import { useEffect, useRef } from 'react';

export const useStableCallback = <T extends (...args: unknown[]) => unknown>(callback: T | undefined) => {
  const funcRef = useRef(callback);

  useEffect(() => {
    funcRef.current = callback;
  }, [callback]);

  return funcRef;
};
